import { InitiateReportRequest, MdaReportType } from 'src/features/clients/client/reportsV2/store/types';

const reportFieldKeys: (keyof InitiateReportRequest)[] = [
  'contributionsAndWithdrawals',
  'assetAllocation',
  'assetClassPerformance',
  'holdingsVsTargetVariance',
  'cashTransactions',
  'expenses',
  'incomeReport',
  'securityPerformance',
  'portfolioSnapshot',
  'portfolioPerformance',
  'portfolioValuation',
  'securityContribution',
  'taxSummary',
  'taxInvoice',
  'investmentIncomeTaxComponent',
  'transactionHistory',
  'realisedCapitalGainsAndLosses',
  'unrealisedCapitalGainsAndLosses',
  'unrealisedNonCGT',
];

/**
 * Checks which reports are not undefined and then determines the reporting name.
 *
 * @param request {@link InitiateReportRequest}
 */
export function getReportingNames(request: InitiateReportRequest): string {
  const includedReports = reportFieldKeys.reduce((previousValue, key) => {
    if (request[key]) {
      const reportName = MdaReportType[key as keyof typeof MdaReportType];
      previousValue.push(reportName);
    }
    return previousValue;
  }, [] as string[]);
  return includedReports.length > 1 ? 'Multiple Reports' : includedReports[0];
}
